<template>
    <my-node :pageType="pageType"></my-node>
</template>

<script>

import MyNode from "@/views/modules/academic/point/myNode.vue";

export default {
    name: "nodeManage",
    components: {MyNode},
    data() {
        return {
            pageType: 'nodeManage'
        }
    },
}
</script>

<style scoped>

</style>